<template>
  <div class="page">
    <div class="page-main">
      <div class="show-box">
        <div class="box-head">
          <!-- <MHeader></MHeader> -->
          <MShopInfo
            :currentFloorId="currentFloor.id"
            @selectFloor="selectFloor"
          ></MShopInfo>
          <MFloorTab
            :currentFloorId="currentFloor.id"
            @selectFloor="selectFloor"
          ></MFloorTab>
        </div>
        <div class="content-list">
          <div
            class="content-li"
            v-for="(item, index) in floorList"
            :key="index"
          >
            <MFloorArticle
              v-if="item.id == 202"
              :item="item"
              :index="index"
              :current="currentFloor.key == item.key"
              :floorCount="floorList.length"
              @selectFloor="selectFloor"
            ></MFloorArticle>
            <MFloorVideo
              v-if="item.id == 203"
              :item="item"
              :index="index"
              :current="currentFloor.key == item.key"
              :floorCount="floorList.length"
              @selectFloor="selectFloor"
            >
            </MFloorVideo>
            <MFloorResource
              v-if="item.id == 204"
              :item="item"
              :index="index"
              :current="currentFloor.key == item.key"
              :floorCount="floorList.length"
              @selectFloor="selectFloor"
            >
            </MFloorResource>
            <MFloorAlbum
              v-if="item.id == 205"
              :item="item"
              :index="index"
              :current="currentFloor.key == item.key"
              :floorCount="floorList.length"
              @selectFloor="selectFloor"
            >
            </MFloorAlbum>
            <MFloorNav
              v-if="item.id == 206"
              :item="item"
              :index="index"
              :current="currentFloor.key == item.key"
              :floorCount="floorList.length"
              @selectFloor="selectFloor"
            >
            </MFloorNav>
            <MFloorSwiper
              v-if="item.id == 207"
              :item="item"
              :index="index"
              :current="currentFloor.key == item.key"
              :floorCount="floorList.length"
              @selectFloor="selectFloor"
            ></MFloorSwiper>
            <MFloorEditor
              v-if="item.id == 208"
              :item="item"
              :index="index"
              :current="currentFloor.key == item.key"
              :floorCount="floorList.length"
              @selectFloor="selectFloor"
            ></MFloorEditor>
            <MFloorDiscount
              v-if="item.id == 209"
              :item="item"
              :index="index"
              :current="currentFloor.key == item.key"
              :floorCount="floorList.length"
              @selectFloor="selectFloor"
            >
            </MFloorDiscount>
          </div>
        </div>
        <div class="bottom-tips">
          <img
            src="../../assets/images/m-decoration/m-bottom-icon.png"
            alt=""
            class="bottom-icon"
          />
          <p>提供技术支持</p>
        </div>
      </div>
      <div class="add-box">
        <p class="add-box-title">
          <span>+</span>
          <span>添加左侧楼层</span>
        </p>
        <ul class="floor-list">
          <li
            class="floor-li"
            v-for="(item, index) in floorType"
            :key="index"
            @click="addFloor(item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
    <!-- 侧边栏 -->
    <MAside :floor="currentFloor"></MAside>
    <!-- 富文本编辑器弹窗 -->
    <MEditorDialog></MEditorDialog>
    <!-- banner轮播图弹窗 -->
    <MSwiperDialog></MSwiperDialog>
    <!-- 文章、视频、资料、专辑选择自定义内容弹窗 -->
    <MDiyDialog></MDiyDialog>
    <!-- 轮播图、快捷导航 选择链接的弹窗 -->
    <MLinkDialog></MLinkDialog>
    <!-- 底部通栏 -->
    <footer class="footer">
      <div class="cancel" @click="cancelDescoration()">取消</div>
      <div class="sure" @click="saveDeccoration()">保存</div>
    </footer>
  </div>
</template>

<script>
import api from "../../assets/js/api";
// import MHeader from "../../components/m-decoration/m-header.vue";
import MShopInfo from "../../components/m-decoration/m-shop-info.vue";
import MAside from "../../components/m-decoration/m-aside.vue";
import MFloorTab from "../../components/m-decoration/floor/m-floor-tab.vue";
import MFloorSwiper from "../../components/m-decoration/floor/m-floor-swiper.vue";
import MFloorArticle from "../../components/m-decoration/floor/m-floor-article.vue";
import MEditorDialog from "../../components/m-decoration/dialog/m-editor-dialog.vue";
import MSwiperDialog from "../../components/m-decoration/dialog/m-swiper-dialog.vue";
import MDiyDialog from "../../components/m-decoration/dialog/m-diy-dialog.vue";
import MLinkDialog from "../../components/m-decoration/dialog/m-link-dialog.vue";
import MFloorVideo from "../../components/m-decoration/floor/m-floor-video.vue";
import MFloorResource from "../../components/m-decoration/floor/m-floor-resource.vue";
import MFloorAlbum from "../../components/m-decoration/floor/m-floor-album.vue";
import MFloorNav from "../../components/m-decoration/floor/m-floor-nav.vue";
import MFloorEditor from "../../components/m-decoration/floor/m-floor-editor.vue";
import MFloorDiscount from "../../components/m-decoration/floor/m-floor-discount.vue";
export default {
  name: "ShopCenterAdminWebMIndexDecoration",
  components: {
    // MHeader,
    MShopInfo,
    MAside,
    MFloorTab,
    MEditorDialog,
    MFloorSwiper,
    MFloorArticle,
    MSwiperDialog,
    MDiyDialog,
    MFloorVideo,
    MFloorResource,
    MFloorAlbum,
    MFloorNav,
    MFloorEditor,
    MLinkDialog,
    MFloorDiscount,
  },
  data() {
    return {
      floorType: [
        // 可添加的楼层列表
        {
          id: 202,
          name: "文章", // 楼层名称
          type: "文章", // 楼层类型
          style: 1, // 1-缩略图 2-列表
          contentOrigin: 1, // 1-默认 2-自定义
          order: "pv$2", // 1-按总浏览排序 create_time-按创建时间排序
          count: 2, // 展示数量
          maxCount: 6, // 最大展示数量
          contentList: [], // 楼层内容列表
        },
        {
          id: 203,
          name: "视频", // 楼层名称
          type: "视频", // 楼层类型
          style: 1, // 1-缩略图
          contentOrigin: 1, // 1-默认 2-自定义
          order: "downloads$2", // month_downloads-按30天内下载排序 create_time-按创建时间排序 (#1-正序 #2-倒序)
          count: 2, // 展示数量
          maxCount: 6, // 最大展示数量
          contentList: [], // 楼层内容列表
        },
        {
          id: 204,
          name: "资料",
          type: "资料", // 楼层类型
          style: 3, // 3-竖版 4-横版
          contentOrigin: 1, // 1-默认 2-自定义
          order: "downloads$2", // month_downloads-按30天内下载排序 create_time-按创建时间排序 (#1-正序 #2-倒序)
          count: 2, // 展示数量
          maxCount: 6, // 最大展示数量
          contentList: [], // 楼层内容列表
        },
        {
          id: 205,
          name: "专辑",
          type: "专辑", // 楼层类型
          style: 3, // 3-竖版 4-横版
          contentOrigin: 1, // 1-默认 2-自定义
          order: "pv$2", // month_downloads-按30天内下载排序 create_time-按创建时间排序 show_time-按更新时间 (#1-正序 #2-倒序)
          count: 2, // 展示数量
          maxCount: 6, // 最大展示数量
          contentList: [], // 楼层内容列表
        },
        {
          id: 206,
          name: "快捷导航",
          count: 1, // 展示数量
          maxCount: 8, // 最大展示数量
          contentList: [
            {
              navName: "",
              navImg: "",
              link: "",
              linkType: "", // 快捷导航所关联的链接是内容还是导航 1-内容 2-导航
            },
          ], // 楼层内容列表 默认一个
        },
        {
          id: 207,
          name: "轮播图",
          maxCount: 5, // 最大展示数量
          contentList: [
            {
              swiperImg: "",
              link: "",
              linkType: "", // 轮播图所关联的链接是内容还是导航 1-内容 2-导航
            },
          ], // 楼层内容列表 默认一个
        },
        {
          id: 208,
          name: "富文本",
          contentHtml: "",
        },
        {
          id: 209,
          name: "限时折扣",
          type: "", // 楼层类型
          style: "", // 1-视频 2-资料
          contentOrigin: 2, // 1-默认 2-自定义
          order: "",
          count: 0, // 展示数量
          maxCount: 12, // 最大展示数量
          contentList: [], // 楼层内容列表
        },
      ],
      showInfo: {}, // 展示的店铺信息
      currentFloor: {
        id: 0,
        index: -1,
        key: 0,
      },
      showEditorDialog: false,
      decorationId: "",
      config: "", // 装修信息存储
      isSaved: false,
    };
  },
  computed: {
    floorList() {
      return this.$store.state.mDecoration.floorList;
    },
  },
  // 路由守卫
  beforeRouteLeave(to, from, next) {
    // 如果保存操作后的跳转 直接跳转
    if (this.isSaved) {
      next();
    } else {
      this.$confirm("此时离开将丢失已编辑的内容，是否确认离开？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 恢复vuex中的数据
          this.returnVuex();
          next();
        })
        .catch(() => {
          next(false);
          this.$store.commit(
            "setActiveIndex",
            "/info/shop/shop-decoration-index"
          );
        });
    }
  },
  mounted() {
    this.decorationId = this.$route.query.id;

    this.getDecoration();
  },

  methods: {
    // 获取装修配置信息
    async getDecoration() {
      const res = await this.$axios.post(api.dataShow.getShopStyleList, {
        id: this.decorationId,
        shopId: Number(this.$store.state.user.userInfo.shopId),
        pageIndex: 1,
        pageSize: 1,
      });
      // 如果是新建装修则不进行后续处理
      if (!res.list[0] || res.list[0].config == "{}") {
        return;
      }
      this.config = JSON.parse(res.list[0].config);
      // console.log("移动端装修数据config------", this.config);
      // 更新数据到vuex中
      this.$store.commit("mDecoration/setTabList", this.config.tabList);
      this.$store.commit("mDecoration/setShopState", this.config.showState);

      // 处理楼层数据
      this.config.floorList.forEach((item) => {
        if (item.contentOrigin === 1) {
          this.getDecorationContent(item, false);
        } else {
          if ([202, 203, 204, 205].includes(item.id)) {
            // 针对文章、视频、资料、专辑未知情况下出现获取不到id的问题 把所有null给剔除掉
            item.contentList = item.contentList.filter((item2) => {
              if (item2) return item2;
            });
          }
          this.getDecorationContent(item, true);
        }
      });
    },
    // 填充装修配置中的楼层数据
    async getDecorationContent(item, isZDY = false) {
      let res;
      let params = {
        shopId: Number(this.$store.state.user.userInfo.shopId),
        pageIndex: 1,
        pageSize: item.count,
        sortRule: isZDY ? "" : item.order,
      };
      // 文章楼层
      if (item.id == 202) {
        // 如果是自定义的内容 且没有数据 则不请求
        if (isZDY && item.contentList.length == 0) return;
        // 如果是自定义的内容 且有数据 则根据id请求
        if (isZDY) {
          params.articleIds = item.contentList;
          // 置空排序字段
          params.sortRule = "";
          // 重置pageSize
          params.pageSize = item.contentList.length;
        }
        res = await this.$axios.post(api.decoration.getArticleListEs, params);
        res = res.result;
      }
      // 视频楼层
      else if (item.id == 203) {
        params.queryType = 2; // 1-资料 2-视频
        // 如果是自定义的内容 且没有数据 则不请求
        if (isZDY && item.contentList.length == 0) return;
        // 如果是自定义的内容 且有数据 则根据id请求
        if (isZDY) {
          params.documentIds = item.contentList;
          // 置空排序字段
          params.sortRule = "";
          // 重置pageSize
          params.pageSize = item.contentList.length;
        }
        res = await this.$axios.post(
          api.decoration.getVideoOrResourceList,
          params
        );
      } // 资料楼层
      else if (item.id == 204) {
        params.queryType = 1; // 1-资料 2-视频
        // 如果是自定义的内容 且没有数据 则不请求
        if (isZDY && item.contentList.length == 0) return;
        // 如果是自定义的内容 且有数据 则根据id请求
        if (isZDY) {
          params.documentIds = item.contentList;
          // 置空排序字段
          params.sortRule = "";
          // 重置pageSize
          params.pageSize = item.contentList.length;
        }
        res = await this.$axios.post(
          api.decoration.getVideoOrResourceList,
          params
        );
      } // 专辑楼层
      else if (item.id == 205) {
        // 如果是自定义的内容 且没有数据 则不请求
        if (isZDY && item.contentList.length == 0) return;
        // 如果是自定义的内容 且有数据 则根据id请求
        if (isZDY) {
          params.albumIds = item.contentList;
          // 重置pageSize
          params.pageSize = item.contentList.length;
        }
        res = await this.$axios.post(api.decoration.getAlbumList, params);
      } else if (item.id == 209) {
        params.activityState = 1; // 0-非活动 1-活动
        params.queryType = item.style; // 1-资料 2-视频
        // 如果是自定义的内容 且没有数据 则不请求
        if (isZDY && item.contentList.length == 0) return;
        params.documentLineActivity = item.contentList;
        // 置空排序字段
        params.sortRule = "";
        // 重置pageSize
        params.pageSize = item.contentList.length;

        res = await this.$axios.post(
          api.decoration.getVideoOrResourceList,
          params
        );
      } else {
        // 其他楼层数据不变
        res = {
          list: item.contentList,
        };
      }
      item.contentList = res?.list || [];
      // 每加载完一个楼层数据 就更新一次vuex中的数据
      this.$store.commit("mDecoration/setFloorList", this.config.floorList);
    },
    // 选中楼层
    selectFloor(floor) {
      // console.log("currentFlorr---", floor);
      // 如果是点击的当前选中的楼层则不做任何操作
      if (
        floor.id == this.currentFloor.id &&
        this.currentFloor.key == floor.key
      ) {
        if (floor.index !== this.currentFloor.index) {
          this.currentFloor.index = floor.index;
        }
        return;
      }
      // 如果是删除楼层 结束操作
      if (floor.id == 0 && floor.index == -1) {
        this.currentFloor = {};
        return;
      }
      // 检验必填项
      if (!this.checkFloor()) {
        return;
      }
      // 如果是店铺信息/tab导航 则不进行后续操作
      if (floor.index == -1) {
        this.currentFloor = floor;
        return;
      }
      this.currentFloor = floor;
      const info = JSON.parse(
        JSON.stringify(this.$store.state.mDecoration.floorList[floor.index])
      );
      // 更新数据到vuex中
      this.$store.commit("mDecoration/setCurrentFloor", info);
    },
    // 添加楼层
    async addFloor(floor) {
      // 检验是否超出楼层限制
      if (this.floorList.length == 15) {
        this.$message.error("最多可添加15个楼层，已达到最多数量~");
        return;
      }
      // 检验必填项
      if (!this.checkFloor()) {
        return;
      }
      const obj = Object.assign({ key: Date.now() }, { ...floor });
      // 如果是折扣楼层 则清空名称
      if (obj.id == 209) {
        obj.name = "";
      }
      // 更新数据到vuex中
      const list = JSON.parse(
        JSON.stringify(this.$store.state.mDecoration.floorList)
      );
      // 选中楼层
      this.currentFloor = {
        id: obj.id,
        index: list.length,
        key: obj.key,
      };
      list.push(obj);
      this.$store.commit("mDecoration/setFloorList", list);
      this.$store.commit("mDecoration/setCurrentFloor", obj);
    },
    // 检验楼层必填项
    checkFloor() {
      // 无选中楼层 无需校验
      if (!this.currentFloor?.id) {
        return true;
      }
      // 获取当前楼层在楼层列表中的索引index
      const index = this.floorList.findIndex(
        (item) => item.key == this.currentFloor.key
      );
      // 校验店铺信息楼层
      if (this.currentFloor.id == 200) {
        if (this.$store.state.mDecoration.shopState.length == 0) {
          this.$message.error("店铺信息不能为空");
          return false;
        }
      }
      // 校验导航楼层
      else if (this.currentFloor.id == 201) {
        for (let i = 0; i < this.$store.state.mDecoration.tabList.length; i++) {
          if (this.$store.state.mDecoration.tabList[i].alias.length === 0) {
            this.$message.error("导航名称不能为空");
            return false;
          }
        }
      } else {
        // 校验楼层名称
        if (
          this.floorList[index].name.length === 0 &&
          this.currentFloor.id != 206 &&
          this.currentFloor.id != 208 &&
          this.currentFloor.id != 209
        ) {
          this.$message.error("楼层名称不能为空");
          return false;
        }
        // 校验楼层数量
        if (
          this.floorList[index].count == "" ||
          this.floorList[index].count == 0
        ) {
          this.$message.error("楼层展示数量不能为0");
          return false;
        }
        // 校验自定义内容数量
        if (
          this.floorList[index].contentOrigin === 2 &&
          this.floorList[index].contentList.length === 0
        ) {
          this.$message.error("楼层内容不能为空");
          return false;
        }
        // 校验快捷导航楼层
        if (this.currentFloor.id == 206) {
          if (this.floorList[index]?.contentList.length == 0) {
            this.$message.error("楼层内容不能为空");
            return false;
          }
          for (let i = 0; i < this.floorList[index]?.contentList.length; i++) {
            if (this.floorList[index]?.contentList[i].navName.length === 0) {
              this.$message.error("快捷导航名称不能为空");
              return false;
            } else if (
              this.floorList[index]?.contentList[i].navImg.length === 0
            ) {
              this.$message.error("快捷导航图片不能为空");
              return false;
            }
          }
        }
        // 校验轮播图楼层
        if (this.currentFloor.id == 207) {
          if (this.floorList[index]?.contentList.length == 0) {
            this.$message.error("楼层内容不能为空");
            return false;
          }
          for (let i = 0; i < this.floorList[index].contentList.length; i++) {
            if (this.floorList[index].contentList[i].swiperImg.length === 0) {
              this.$message.error("轮播图图片不能为空");
              return false;
            }
          }
        }
      }
      return true;
    },
    // 保存店铺装修数据
    async saveDeccoration() {
      // 检验必填项
      if (this.floorList.length > 0 && !this.checkFloor()) {
        return;
      }
      // 店铺信息楼层单独处理
      let showState = JSON.parse(
        JSON.stringify(this.$store.state.mDecoration.shopState)
      );
      // 获取导航楼层单独处理
      let topTabList = JSON.parse(
        JSON.stringify(this.$store.state.mDecoration.tabList)
      );
      // 重置排序字段
      topTabList.forEach((item, index) => {
        item.sort = index + 1;
      });
      // 将导航楼层在左侧楼层列表中删除
      const floorList2 = JSON.parse(JSON.stringify(this.floorList));
      // 判断是都有楼层内容为空 避免楼层内容全部下架、活动全都结束等情况
      let isNull = null;
      const mainFloorList = floorList2.map((floor) => {
        let item = JSON.parse(JSON.stringify(floor));
        // 如果是默认内容 则直接清空 展示时根据默认规则再请求具体数据
        if (item.contentOrigin && item.contentOrigin === 1) {
          item.contentList = [];
        }
        // 如果是自定义内容 则只保存id 展示时根据id再请求具体数据 （排除折扣楼层）
        if (item.contentOrigin && item.contentOrigin === 2 && item.id != 209) {
          item.contentList = item.contentList.map((item2) => {
            if (item2) {
              return (
                item2.documentId || item2.albumId || item2.articleId || null
              );
            } else {
              // 针对未知情况下出现null 则返回null
              return null;
            }
          });
          // 针对未知情况下出现获取不到id的问题 把所有null给剔除掉
          item.contentList = item.contentList.filter((item2) => {
            if (item2) return item2;
          });
          item.count = item.contentList.length;
          // 如果发现有楼层内容为空 则记录当前楼层
          if (!isNull && item.contentList.length == 0) {
            isNull = floor;
          }
        }
        // 单独处理折扣楼层
        if (item.id == 209) {
          item.contentList = item.contentList.map((item2) => {
            return item2.documentId + "_" + item2.activityInfo?.activityId;
          });
          item.count = item.contentList.length;
          // 如果发现有楼层内容为空 则记录当前楼层
          if (!isNull && item.contentList.length == 0) {
            isNull = floor;
          }
        }
        return item;
      });
      if (isNull) {
        this.$message.error("存在楼层内容为空，请添加内容后再保存~");
        let info = {};
        this.floorList.forEach((item, index) => {
          if (item.key == isNull.key) {
            info = {
              id: item.id,
              index: index,
              key: item.key,
            };
          }
        });
        // 选中楼层
        this.selectFloor(info);
        // 结束函数
        return;
      }
      const config = JSON.stringify({
        showState: showState,
        tabList: topTabList,
        floorList: mainFloorList,
      });
      // console.log("保存的移动端装修数据config------", config);
      const res = await this.$axios.post(api.decoration.updateDecoration, {
        id: this.decorationId,
        config: config,
      });
      if (res.valid && res.result) {
        this.isSaved = true;
        // 恢复vuex中的数据
        this.returnVuex();
        this.$message.success("当前店铺装修已保存~");
        this.$router.push({
          name: "shop-decoration-index",
          params: {
            isM: true,
          },
        });
      } else {
        const error = JSON.parse(res.error.message);
        // 存在风险词
        if (error.conclusionType === 1) {
          let text = "";
          error.hits.forEach((item) => {
            item.detectionResult.forEach((item2) => {
              text += item2.keyword + "、";
            });
          });
          text = text.slice(0, text.length - 1);
          this.$message({
            message: `您编辑的内容中存在以下风险词汇：${text}，请修改后再保存~`,
            type: "warning",
          });
          return;
        }
      }
    },
    // 取消按钮
    cancelDescoration() {
      this.$router.push({
        name: "shop-decoration-index",
        params: {
          isM: true,
        },
      });
    },
    // 恢复Vuex的原始数据
    returnVuex() {
      // 更新vuex的数据为原始数据
      this.$store.commit("mDecoration/setDecoration", {});
      this.$store.commit("mDecoration/setTabList", [
        {
          alias: "文章",
          menuType: 1,
          content: "",
          sort: 1,
        },
        {
          alias: "视频",
          menuType: 2,
          content: "",
          sort: 2,
        },
        {
          alias: "资料",
          menuType: 3,
          content: "",
          sort: 3,
        },
        {
          alias: "专辑",
          menuType: 4,
          content: "",
          sort: 4,
        },
        {
          alias: "简介",
          menuType: 5,
          content: "",
          sort: 5,
        },
      ]);
      this.$store.commit("mDecoration/setShopState", [
        {
          id: 1081,
          name: "浏览量",
          checked: true,
          type: "documentTotalPv",
        },
        {
          id: 1082,
          name: "下载量",
          checked: true,
          type: "documentTotalDownload",
        },
      ]);
      this.$store.commit("mDecoration/setFloorList", []);
      this.$store.commit("mDecoration/setDialogType", "");
      this.$store.commit("mDecoration/setCurrentFloor", {});
      this.$store.commit("mDecoration/setDIYDialogInfo", {});
      this.$store.commit("mDecoration/setCurrentContentIndex", 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding-top: 15px;
  padding-right: 380px;
  padding-bottom: 90px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  .page-main {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 868px;
    max-width: 868px;
    min-width: 600px;
    margin-right: 40px;
    .show-box {
      position: relative;
      width: 375px;
      min-height: 500px;
      // min-height: 660px;
      padding-bottom: 40px;
      background: #f6f6f6;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.25);
      .box-head {
        height: 160px;
        padding-top: 60px;
        // background: #378eff;
        background: url(../../assets/images/m-decoration/m-header-bg.png)
          no-repeat;
        background-size: 100% 100%;
      }
      .bottom-tips {
        position: absolute;
        bottom: 17px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        .bottom-icon {
          width: 52px;
          height: 16px;
          margin: -2px 3px 0 0;
        }
        p {
          color: #8895a9;
          font-size: 13px;
          line-height: 13px;
        }
      }
    }
    .add-box {
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      width: calc(100% - 32px);
      height: 90px;
      margin: 20px auto 0;
      background: #ffffff;
      border: 1px dashed #5a83ff !important;
      border-radius: 5px;

      .add-box-title {
        font-size: 14px;
        color: #5a83ff;

        span {
          &:first-child {
            margin-right: 5px;
            font-size: 18px;
            font-weight: 500;
            color: #5a83ff;
          }
        }
      }

      .floor-list {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-top: 10px;

        .floor-li {
          flex-shrink: 1;
          width: 78px;
          max-width: 78px;
          height: 26px;
          margin-right: 9px;
          background: #ffffff;
          border: 1px solid #dddfe6;
          border-radius: 4px;
          text-align: center;
          line-height: 26px;
          font-size: 12px;
          color: #333;
          cursor: pointer;

          &:first-child {
            margin-left: 9px;
          }

          &:hover {
            color: #5a83ff;
            border-color: #5a83ff;
          }
        }
      }
    }
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 0px;
    right: 0px;
    z-index: 2;
    width: calc(100% + 40px);
    height: 70px;
    background-color: #fff;

    .cancel {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 96px;
      height: 32px;
      margin-right: 60px;
      transform: translateX(120px);
      background: #ffffff;
      border: 1px solid #dddfe6;
      border-radius: 3px;
      color: #606266;
      cursor: pointer;
    }
    .sure {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 96px;
      height: 32px;
      transform: translateX(120px);
      color: #fff;
      background: #5a83ff;
      border-radius: 3px;
      cursor: pointer;
    }
  }
}
</style>
<style>
.el-input__count-inner {
  color: #c4c8d0 !important;
}
.el-scrollbar__thumb {
  background-color: #e3e3e3 !important;
}
.el-radio__input.is-checked + .el-radio__label {
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
  color: #606266;
}
.el-radio__label {
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
  color: #606266;
}
.el-input input::placeholder {
  font-size: 12px !important;
}
.el-input input::-webkit-input-placeholder {
  font-size: 12px !important;
}
.el-input input::-moz-input-placeholder {
  font-size: 12px !important;
}
</style>
